// Helpers
import { getPayPlansEditAccess, getPayPlansViewAccess } from "@/Common/helpers/Positions/positionsAccess";

const hasEditAccess = (position, isPresentAccess = () => {}) => {
	const access = getPayPlansEditAccess(position);
	return isPresentAccess?.(access) || false;
};

const hasViewAccess = (position, isPresentAccess = () => {}) => {
	const access = getPayPlansViewAccess(position);
	return isPresentAccess?.(access) || false;
};

export { hasEditAccess, hasViewAccess };
